import React, { createContext, useContext } from 'react';

import { SHOPPER_EMAILS_PAGE_SIZE } from '../constants';
import { ShopperEmailType } from '../types';

export type ShopperEmailsFiltersType = {
  page: number;
  pageSize: number;
  search: string;
  mailboxStatus: string[];
  linkedShopRequests: string[];
  labelPresence: string[];
  ownerIds: number[];
};

type ShopperEmailsContextType = {
  items: ShopperEmailType[];
  loading: boolean;
  totalItemsCount: number;
  filters: ShopperEmailsFiltersType;
  authenticatingEmailId: number | null;
  setPage: (page: number) => void;
  setFilters: (filters: Partial<ShopperEmailsFiltersType>) => void;
  openCreateModal: () => void;
  openEditModal: (shopperEmail: ShopperEmailType) => void;
  onMailboxAction: (shopperEmail: ShopperEmailType) => Promise<void>;
};

export const ShopperEmailsContext = createContext<ShopperEmailsContextType>({
  items: [],
  loading: false,
  totalItemsCount: 0,
  filters: {
    page: 1,
    pageSize: SHOPPER_EMAILS_PAGE_SIZE,
    search: '',
    mailboxStatus: [],
    linkedShopRequests: [],
    labelPresence: [],
    ownerIds: [],
  },
  authenticatingEmailId: null,
  setPage: () => {
    // Do nothing
  },
  setFilters: () => {
    // Do nothing
  },
  openCreateModal: () => {
    // Do nothing
  },
  openEditModal: () => {
    // Do nothing
  },
  onMailboxAction: async () => {
    // Do nothing
  },
});

export const useShopperEmailsContext = () => useContext(ShopperEmailsContext);
